"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Languages = void 0;
var Languages;
(function (Languages) {
    let Ids;
    (function (Ids) {
        Ids["FR"] = "fr";
        Ids["EN"] = "en";
    })(Ids = Languages.Ids || (Languages.Ids = {}));
    Languages.defaultLanguage = {
        id: Ids.FR,
        friendlyName: "Français",
    };
    Languages.supportedLanguages = {
        byId: {
            en: {
                id: Ids.EN,
                friendlyName: "English",
            },
            fr: {
                id: Ids.FR,
                friendlyName: "Français",
            },
        },
        allIds: [Ids.EN, Ids.FR],
    };
})(Languages = exports.Languages || (exports.Languages = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGFuZ3VhZ2VzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2xpYi9MYW5ndWFnZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBaUIsU0FBUyxDQXlCekI7QUF6QkQsV0FBaUIsU0FBUztJQUN4QixJQUFZLEdBR1g7SUFIRCxXQUFZLEdBQUc7UUFDYixnQkFBUyxDQUFBO1FBQ1QsZ0JBQVMsQ0FBQTtJQUNYLENBQUMsRUFIVyxHQUFHLEdBQUgsYUFBRyxLQUFILGFBQUcsUUFHZDtJQUVZLHlCQUFlLEdBQUc7UUFDN0IsRUFBRSxFQUFFLEdBQUcsQ0FBQyxFQUFFO1FBQ1YsWUFBWSxFQUFFLFVBQVU7S0FDekIsQ0FBQztJQUVXLDRCQUFrQixHQUFHO1FBQ2hDLElBQUksRUFBRTtZQUNKLEVBQUUsRUFBRTtnQkFDRixFQUFFLEVBQUUsR0FBRyxDQUFDLEVBQUU7Z0JBQ1YsWUFBWSxFQUFFLFNBQVM7YUFDeEI7WUFDRCxFQUFFLEVBQUU7Z0JBQ0YsRUFBRSxFQUFFLEdBQUcsQ0FBQyxFQUFFO2dCQUNWLFlBQVksRUFBRSxVQUFVO2FBQ3pCO1NBQ0Y7UUFDRCxNQUFNLEVBQUUsQ0FBQyxHQUFHLENBQUMsRUFBRSxFQUFFLEdBQUcsQ0FBQyxFQUFFLENBQUM7S0FDekIsQ0FBQztBQUVKLENBQUMsRUF6QmdCLFNBQVMsR0FBVCxpQkFBUyxLQUFULGlCQUFTLFFBeUJ6QiJ9